import React, { useEffect, useState } from 'react';
import "./review-modal.scss"
import { Modal, Select } from "antd";
import { useSelector } from 'react-redux';
import { Http } from '../../../../../helpers/axois';
import { logger } from '../../../../../constant/winston';

import moment from 'moment';
import WidgetRating from '../../WidgetRating';

import { ReactComponent as CloseIcon } from "../../../../../assets/svg/roundedCloseIcon.svg";
import { useToast } from '../../../../../helpers/commonFunction';
import { AppState } from '../../../../../stateManager/store';

const { Option } = Select;

const ReviewModal: React.FC<any> = ({ avgRating, visible, setVisible, productId }) => {
  // const [shownComments, setShownComments] = useState<any>({});
  const [reviews, setReviews] = useState<any>([]);
  const {ErrorToast}=useToast();
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  const selectedOrgId = useSelector((state: any) => state.org.selectedOrg.id)
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  const handleChange = (value: any) => {
    const sortedMostrecent = [...reviews]
    if (value === "All Ratings") {
      setReviews(sortedMostrecent);
    }

    if (value === "Latest") {
      const sortedLatest = [...reviews]
      sortedLatest.sort((a: any, b: any) =>
        new Date(b.reviewed_at).getTime() - new Date(a.reviewed_at).getTime())
      setReviews(sortedLatest)
    }

    if (value === "Old") {
      const sortedOld = [...reviews]
      sortedOld.sort((a: any, b: any) =>
        new Date(a.reviewed_at).getTime() - new Date(b.reviewed_at).getTime())
      setReviews(sortedOld)
    }
  }

  // const toggleComment = (review_id: any) => {
  //   setShownComments((prevShownComments: any) => ({
  //     ...prevShownComments,
  //     [review_id]: !prevShownComments[review_id]
  //   }));
  // };

  useEffect(() => {
    if ((!orgPermissions?.includes("marketplace.PublishWidget") || !orgPermissions.includes('org.View'))&&  loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Error fetching review")
      return
    } 
    Http.get(
      `/orgs/${selectedOrgId}/store/products/${productId}/review`
    ).subscribe((res: any) => {
      if (res) {
        setReviews(res);
      } else {
        logger.error("error");
      }
    }, (err) => {
      if (err === "Forbidden") {
        ErrorToast("Not Authorized: Error fetching review")
    }
    });
  }, [productId, selectedOrgId, visible]);

  return (
    <Modal
      title="REVIEWS"
      visible={visible}
      maskClosable={false}
      className="override-modal"
      style={{
        top: 150,
      }}
      width="1100px"
      closeIcon={
        <CloseIcon
          data-test-id="close_icon"
          height="18px"
          width="18px"
          onClick={() => setVisible(false)}
        />
      }
      footer={false}
      maskStyle={{
        background: "#0000001",
      }}
    >
      <div className="reviews-modal">
        <div className="reviews-header">
          <div className="reviews-title"> Average Ratings </div>
          <div className="rating-body">
            <div className="customer-rating">
              <WidgetRating avgRating={avgRating} height={20} />
              <div className="total-ratings">{reviews.length} ratings</div>
            </div>
            <div className="average-rating"> {avgRating}</div>
            <div className="vl"> </div>
            <div className="review-filter">
              <Select defaultValue="Most Recent" style={{ width: 120 }} onChange={handleChange} >
                <Option value="Most Recent">Most Recent</Option>
                <Option value="Latest">Latest to Old</Option>
                <Option value="Old">Old to Latest</Option>
              </Select>
            </div>
          </div>
          <hr />
        </div>
        {reviews.map((reviewData: any, index: number) => {
          const { rating, review,  reviewed_by, id, title, reviewed_at } = reviewData;
          const { first_name, last_name } = reviewed_by;
          return (
            <div className="review-body" key={index || id}>
              <div className="review-card">
                <div className="review">
                  <div>
                    <div className="review-card-title">{title}</div>
                    <div className="review-card-subtitle">
                    {first_name[0].toUpperCase()}{first_name.substr(1)} {last_name} {moment(reviewed_at).format("MMM Do YYYY")}
                    </div>
                  </div>
                  <div className="review-card-rating">
                    <WidgetRating avgRating={rating} height={20} />
                  </div>
                </div>
                <div className="review-card-body"> {review} </div>
                {/* <div className="review-card-footer">
                  {id ? (
                    <button
                      onClick={() => toggleComment(id)}
                      className="reply-button"
                    >
                      {shownComments[id] ? "Cancel" : "Reply"}
                    </button>) : null}
                </div> */}
              </div>
              {/* {shownComments[id] ?
                <div className="reply-nested-comment">
                  <textarea
                    className="ant-input text-area"
                    onChange={(e) => e.target.value}
                  />
                  <div className="reply-button" >Reply</div>
                </div>
                : null} */}
              <hr />
            </div>
          );
        })}
      </div>
    </Modal>
  )
}

export default ReviewModal
